export const THUNDERBITE = 'THUNDERBITE';
export const SPLASHTECH = 'SPLASHTECH';
export const CASINO = 'casino';
export const SPORTSBOOK = 'sportsbook';
export const SPORTS = 'sports';
export const META_KEYWORDS_FREE_TO_PLAY = 'META_KEYWORDS_FREE_TO_PLAY';
export const META_DESCRIPTION_FREE_TO_PLAY = 'META_DESCRIPTION_FREE_TO_PLAY';
export const FREE_TO_PLAY_SITE_TITLE = 'FREE_TO_PLAY_SITE_TITLE';
export const FREE_TO_PLAY_BANNER_CAROUSEL_TITLE = 'FREE_TO_PLAY_BANNER_CAROUSEL_TITLE';
export const FREE_TO_PLAY_BANNER_CAROUSEL_NO_ITEMS_TITLE = 'FREE_TO_PLAY_BANNER_CAROUSEL_NO_ITEMS_TITLE';
export const FREE_TO_PLAY_BANNER_CAROUSEL_TITLE_LOGGED_OUT = 'FREE_TO_PLAY_BANNER_CAROUSEL_TITLE_LOGGED_OUT';
export const FREE_TO_PLAY_BANNER_CAROUSEL_SUBTITLE = 'FREE_TO_PLAY_BANNER_CAROUSEL_SUBTITLE';
export const FREE_TO_PLAY_BANNER_CAROUSEL_NO_ITEMS_SUBTITLE = 'FREE_TO_PLAY_BANNER_CAROUSEL_NO_ITEMS_SUBTITLE';
export const FREE_TO_PLAY_BANNER_CAROUSEL_SUBTITLE_LOGGED_OUT = 'FREE_TO_PLAY_BANNER_CAROUSEL_SUBTITLE_LOGGED_OUT';
export const FREE_TO_PLAY_BANNER_CAROUSEL_PLAY_FOR_FREE_BUTTON = 'FREE_TO_PLAY_BANNER_CAROUSEL_PLAY_FOR_FREE_BUTTON';
export const FREE_TO_PLAY_LOG_IN_BUTTON = 'FREE_TO_PLAY_LOG_IN_BUTTON';
export const PLAY_NOW = 'PLAY_NOW';
export const FREE_TO_PLAY_BANNER_CAROUSEL_LOGGED_OUT_BACKGROUND_IMAGE_THUNDERBITE =
	'FREE_TO_PLAY_BANNER_CAROUSEL_LOGGED_OUT_BACKGROUND_IMAGE_THUNDERBITE';
export const FREE_TO_PLAY_BANNER_CAROUSEL_LOGGED_OUT_BACKGROUND_IMAGE_SPLASHTECH =
	'FREE_TO_PLAY_BANNER_CAROUSEL_LOGGED_OUT_BACKGROUND_IMAGE_SPLASHTECH';
export const FREE_TO_PLAY_RECOMMENDED_GAMES = 'FREE_TO_PLAY_RECOMMENDED_GAMES';
export const FREE_TO_PLAY_RECOMMENDED_BETS = 'FREE_TO_PLAY_RECOMMENDED_BETS';
export const FREE_TO_PLAY_BANNER_CARD_IMAGE_SPORTSBOOK = 'FREE_TO_PLAY_BANNER_CARD_IMAGE_SPORTSBOOK';
export const RECOMMENDATIONS_KEY = 'FREE_TO_PLAY_HUB' as string;
export const FREE_TO_PLAY_PROMO_NO_DATA_TITLE = 'FREE_TO_PLAY_PROMO_NO_DATA_TITLE';
export const FREE_TO_PLAY_PROMO_NO_DATA_SUBTITLE = 'FREE_TO_PLAY_PROMO_NO_DATA_SUBTITLE';
export const FREE_TO_PLAY_PROMO_NO_DATA_BUTTON_TEXT = 'FREE_TO_PLAY_PROMO_NO_DATA_BUTTON_TEXT';
export const FREE_TO_PLAY_PROMO_COUNT_DOWN_TEXT = 'FREE_TO_PLAY_PROMO_COUNT_DOWN_TEXT';
export const FREE_TO_PLAY_PROMO_DATA_ERROR_TITLE = 'FREE_TO_PLAY_PROMO_DATA_ERROR_TITLE';
export const FREE_TO_PLAY_PROMO_DATA_ERROR_SUBTITLE = 'FREE_TO_PLAY_PROMO_DATA_ERROR_SUBTITLE';

export const TEXT_KEYS = [
	META_KEYWORDS_FREE_TO_PLAY,
	META_DESCRIPTION_FREE_TO_PLAY,
	FREE_TO_PLAY_SITE_TITLE,
	FREE_TO_PLAY_BANNER_CAROUSEL_TITLE,
	FREE_TO_PLAY_BANNER_CAROUSEL_NO_ITEMS_TITLE,
	FREE_TO_PLAY_BANNER_CAROUSEL_TITLE_LOGGED_OUT,
	FREE_TO_PLAY_BANNER_CAROUSEL_SUBTITLE,
	FREE_TO_PLAY_BANNER_CAROUSEL_NO_ITEMS_SUBTITLE,
	FREE_TO_PLAY_BANNER_CAROUSEL_SUBTITLE_LOGGED_OUT,
	FREE_TO_PLAY_BANNER_CAROUSEL_PLAY_FOR_FREE_BUTTON,
	FREE_TO_PLAY_LOG_IN_BUTTON,
	PLAY_NOW,
	FREE_TO_PLAY_RECOMMENDED_GAMES,
	FREE_TO_PLAY_RECOMMENDED_BETS,
	FREE_TO_PLAY_PROMO_NO_DATA_TITLE,
	FREE_TO_PLAY_PROMO_NO_DATA_SUBTITLE,
	FREE_TO_PLAY_PROMO_NO_DATA_BUTTON_TEXT,
	FREE_TO_PLAY_PROMO_COUNT_DOWN_TEXT,
	FREE_TO_PLAY_PROMO_DATA_ERROR_TITLE,
	FREE_TO_PLAY_PROMO_DATA_ERROR_SUBTITLE
];
export const RESOURCE_KEYS = [
	FREE_TO_PLAY_BANNER_CAROUSEL_LOGGED_OUT_BACKGROUND_IMAGE_THUNDERBITE,
	FREE_TO_PLAY_BANNER_CAROUSEL_LOGGED_OUT_BACKGROUND_IMAGE_SPLASHTECH
];

export enum StaleTime {
	ZERO = 0, // Should be used as default for all requests (Always fresh data on demand).
	// Uncomment and use others only if you know what you are doing.
	THIRTY_SECONDS = 30 * 1000, // 30 seconds
	SHORT = 60 * 1000, // 1 minute
	MODERATE = 5 * 60 * 1000, // 5 minutes
	LONG = 15 * 60 * 1000 // 15 minutes
	// INFINITE = Infinity // Never expires
}

export enum RefetchInterval {
	SHORT = 60 * 1000, // 1 minute
	MODERATE = 5 * 60 * 1000, // 5 minutes
	LONG = 15 * 60 * 1000 // 15 minutes
}
